/** -- external-- */

import React from "react";
import _ from "lodash";
import classNames from "classnames";

/** -- internal-- */

import { DataGrid } from "@toddle-edu/ds-data-grid";
import { Tooltip } from "@toddle-edu/ds-web";

/** -- relative-- */

import classes from "./AddonsDatagrid.scss";
import {
  getDatagridHeaders,
  getDatagridData,
} from "./modules/AddonsDatagridUtils";
import { getCurriculumPrograms } from "../../modules/AddOnManagerUtils";

const AddonsDatagrid = ({
  organizationDetails,
  addOnOptions,
  isAccountDatagrid,
  addOnsStatus,
  isLoading,
  onToggleCheckbox,
  toggleAddOn,
  configurationState,
  t,
}) => {
  const entityList = isAccountDatagrid
    ? [organizationDetails]
    : getCurriculumPrograms({ organizationDetails });

  const datagridHeaders = getDatagridHeaders({ addOnOptions });
  const datagridData = getDatagridData({
    headers: datagridHeaders,
    entityList,
    isAccountDatagrid,
    addOnsStatus,
    toggleAddOn,
    configurationState,
  });

  const onCellEdit = params => {
    _.forEach(params, editedCell => {
      const { cellCoods, newValue } = editedCell || {};
      const { col, rowId } = cellCoods || {};
      const isChecked = _.get(newValue, "value") === "checked";

      if (rowId == null || col == null) return;

      const addOnId = _.get(datagridHeaders, [col, "id"], null);
      const entityId = rowId;

      if (_.endsWith(addOnId, "_checkbox")) {
        onToggleCheckbox({
          addOnId: addOnId.replace("_checkbox", ""),
          entityId,
          isChecked,
        });
      }
    });
  };

  const getDatagridHeight = () => {
    if (isAccountDatagrid) return "100%";

    const rowCount = _.size(datagridData);
    if (rowCount <= 9) return "100%";
    return "54vh";
  };

  const customColumnClasses = classNames(classes.datagridColumn, "text-label");

  const customHeader = () => {
    const firstColumnLabel = isAccountDatagrid
      ? t("common:account_name")
      : t("common:school_name");

    return (
      <table className={classes.headerTable}>
        <thead>
          <tr>
            <th
              rowSpan={2}
              className={customColumnClasses}
              aria-label={firstColumnLabel}
            >
              <Tooltip tooltip={firstColumnLabel}>
                <div className={classes.headerLabel}>{firstColumnLabel}</div>
              </Tooltip>
            </th>
            {_.map(addOnOptions, addOn => {
              const label = addOn.useLocale ? t(addOn.label) : addOn.label;
              return (
                <th
                  key={addOn.id}
                  colSpan={2}
                  className={customColumnClasses}
                  aria-label={label}
                >
                  <Tooltip tooltip={label}>
                    <div className={classes.headerLabel}>{label}</div>
                  </Tooltip>
                </th>
              );
            })}
          </tr>
        </thead>
      </table>
    );
  };

  return (
    <div className={classes.container}>
      <DataGrid
        data={datagridData}
        headers={datagridHeaders}
        customHeader={customHeader}
        onCellEdit={onCellEdit}
        dataGridWidth={"100%"}
        dataGridHeight={getDatagridHeight()}
        blurSelectionOnOutsideClick={true}
        tooltipDelayTime={500}
        showSkeletonLoader={isLoading}
        rowMarkers="none"
      />
    </div>
  );
};

export default AddonsDatagrid;
